import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import statusImg from './assets/unauth.svg';

// Shared layout for full-page states that aren't a real feature screen — access
// restricted, page not found, etc. — so they read as one consistent "you've hit a
// dead end, here's why, here's the way back" pattern instead of each looking
// different or (before this) just rendering a blank white screen.
export const StatusPage = ({icon, heading, message, buttonLabel = "Back to Dashboard", to = "/"})=>{
    const navigate = useNavigate();

    return(
        <div style={{display:'flex', alignItems:'center', flexDirection:'column', alignContent:'center', justifyContent:'center', height:'90vh', textAlign:'center'}}>
            <img width={180} height={180} src={statusImg} alt="" />

            <div style={{maxWidth:'420px', marginTop:'10px'}}>
                {icon?
                    <FontAwesomeIcon icon={icon} style={{fontSize:'20px', color:'#7c98b6', marginBottom:'10px'}} />
                : null}
                <h4>{heading}</h4>

                <div className="text" style={{marginTop:'8px'}}>
                    {message}
                </div>

                <button
                    className="drawer-filled-btn"
                    style={{marginTop:'24px'}}
                    onClick={()=>navigate(to)}
                >
                    {buttonLabel}
                </button>
            </div>
        </div>
    )
}
